
export default function Services() {
  const services = [
    {
      title: 'Personal Care',
      description: 'Assistance with bathing, grooming, dressing, and daily hygiene routines',
      image: 'https://public.readdy.ai/ai/img_res/36e3f46c3636882e40ebab323f842f19.jpg',
      icon: 'ri-user-heart-line'
    },
    {
      title: 'Companionship',
      description: 'Engaging conversation, activities, and emotional support to reduce isolation',
      image: 'https://readdy.ai/api/search-image?query=light%20skin%20mixed%20race%20male%20caregiver%20with%20warm%20caramel%20complexion%20and%20elderly%20woman%20laughing%20together%20playing%20cards%20at%20a%20wooden%20table%20in%20a%20cozy%20bright%20home%20warm%20afternoon%20sunlight%20joyful%20genuine%20connection%20natural%20realistic&width=400&height=550&seq=svc_mix02&orientation=portrait',
      icon: 'ri-heart-3-line'
    },
    {
      title: 'Meal Preparation',
      description: 'Nutritious meal planning, cooking, and assistance with eating',
      image: 'https://readdy.ai/api/search-image?query=caregiver%20preparing%20fresh%20healthy%20colorful%20vegetables%20and%20meal%20in%20a%20bright%20modern%20home%20kitchen%20warm%20natural%20light%20clean%20countertops%20inviting%20homey%20atmosphere&width=400&height=550&seq=svc_new03&orientation=portrait',
      icon: 'ri-restaurant-line'
    },
    {
      title: 'Light Housekeeping',
      description: 'Maintaining a clean, safe, and comfortable living environment',
      image: 'https://readdy.ai/api/search-image?query=caregiver%20tidying%20and%20organizing%20a%20bright%20airy%20living%20room%20with%20fresh%20flowers%20plants%20soft%20natural%20light%20clean%20tidy%20comfortable%20home%20environment%20warm%20tones&width=400&height=550&seq=svc_new04&orientation=portrait',
      icon: 'ri-home-smile-line'
    },
    {
      title: 'Medication Reminders',
      description: 'Timely reminders to ensure proper medication adherence',
      image: 'https://readdy.ai/api/search-image?query=professional%20caregiver%20handing%20medication%20to%20elderly%20man%20at%20a%20bright%20table%20with%20pill%20organizer%20warm%20caring%20supportive%20home%20environment%20soft%20natural%20lighting&width=400&height=550&seq=svc_new05&orientation=portrait',
      icon: 'ri-medicine-bottle-line'
    },
    {
      title: 'Transportation',
      description: 'Safe rides to appointments, errands, and social activities',
      image: 'https://readdy.ai/api/search-image?query=caregiver%20helping%20smiling%20elderly%20woman%20into%20a%20clean%20car%20on%20a%20sunny%20day%20safe%20gentle%20assistance%20warm%20outdoor%20natural%20light%20suburban%20neighborhood&width=400&height=550&seq=svc_new06&orientation=portrait',
      icon: 'ri-car-line'
    },
    {
      title: 'Respite Care',
      description: 'Temporary relief for family caregivers to rest and recharge',
      image: 'https://readdy.ai/api/search-image?query=elderly%20man%20relaxing%20peacefully%20in%20a%20comfortable%20armchair%20reading%20a%20book%20in%20a%20bright%20cozy%20living%20room%20with%20plants%20warm%20afternoon%20sunlight%20calm%20serene%20atmosphere&width=400&height=550&seq=svc_new07&orientation=portrait',
      icon: 'ri-time-line'
    },
    {
      title: 'Dementia Care',
      description: 'Specialized support for those with Alzheimer\'s and memory challenges',
      image: 'https://readdy.ai/api/search-image?query=gentle%20patient%20caregiver%20doing%20simple%20puzzle%20activity%20with%20elderly%20woman%20at%20a%20table%20calm%20peaceful%20bright%20home%20setting%20soft%20warm%20lighting%20compassionate%20supportive%20care&width=400&height=550&seq=svc_new08&orientation=portrait',
      icon: 'ri-brain-line'
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-12">
          <h2 className="text-5xl font-serif text-[#2C2C2C]">Our Care Services</h2>
          <p className="text-gray-600 max-w-md text-right">
            Personalized support designed around your family's needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer aspect-[3/4]"
            >
              <div className="absolute inset-0">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              </div>

              <div className="absolute top-4 right-4">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center">
                  <i className={`${service.icon} text-[#6B8E6F] text-xl`}></i>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-2xl font-semibold mb-2">{service.title}</h3>
                <p className="text-sm leading-relaxed text-white/90">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
